var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.95 11.692V3.556c0-.307.224-.556.5-.556s.5.249.5.556v8.136l4.096-4.096a.5.5 0 1 1 .707.707L9.51 12.546a1.5 1.5 0 0 1-.924.433.45.45 0 0 1-.273 0 1.5 1.5 0 0 1-.924-.433L3.146 8.303a.5.5 0 1 1 .708-.707z"
  })));
};
export default SvgArrowDown;